import { createAsyncThunk } from '@reduxjs/toolkit';
import { getNormalizedCharters, getNormalizedStages } from '../../../helpers/getNormalized';
import { charterActions } from '../charterSlice/charterSlice';
import { positionActions } from '../positionSlice/positionSlice';
import { gantActions } from '../gantSlice/gantSlice';
import moment from 'moment';
import { removeDuplicates } from '../../../helpers/removeDuplicates';
import { positionsConnectionsActions } from '../positionsConnections/positionsConnectionsSlice';

export const fetchStages = createAsyncThunk('stages/fetchStages', async (url, thunkApi) => {
    const getStagesUrl = routable.getRoute('getEstimateGanttData');

    try {
        const response = await fetch(getStagesUrl, {
            method: 'GET',
        });

        if (!response.ok) {
            const error = await response.json();
            loader.hide();
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('button.ok.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-light',
                },
            }).then(function () {
                window.location.reload();
            });
            return thunkApi.rejectWithValue(error.message);
        }

        const getMhdDurationUrl = routable.getRoute('get_mhd_duration');
        const responseDurationMHD = await fetch(getMhdDurationUrl, {
            method: 'Get',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        const gantDurationMHD = await responseDurationMHD.json();
        const gantData = await response.json();
        const { data } = await gantData;

        if (!data) {
            throw new Error();
        }

        const dataStagesList = data.filter((stage) => stage.positions);

        const { entities, result: stageIds } = getNormalizedStages(dataStagesList);

        const positionsList = entities.positions;

        const stages = stageIds.map((stageId) => entities.stages[stageId]);

        const allPositionsList = [];
        const allCharterList = [];

        for (const item of Object.values(positionsList)) {
            if (item.is_parent) {
                allCharterList.push(item);
            } else {
                allPositionsList.push(item);
            }
        }

        const { charters, children } = getNormalizedCharters(allCharterList).entities;

        const positionsListAll = children
            ? [...allPositionsList, ...Object.values(children)]
            : [...allPositionsList];

        if (charters) thunkApi.dispatch(charterActions.addStages(Object.values(charters)));
        thunkApi.dispatch(positionActions.addStages(positionsListAll));

        const connectionsAll = positionsListAll.flatMap((position) => position.connections);
        const connections = removeDuplicates(connectionsAll);

        thunkApi.dispatch(
            gantActions.changeSettings({
                daysMHD: gantDurationMHD.data.mhd_duration,
                duration: gantData.duration,
                isShowMHD: gantData.viewMaterial,
            })
        );
        thunkApi.dispatch(gantActions.changeTab(gantData.duration));
        thunkApi.dispatch(gantActions.changeIsLoading(false));
        const firstStageStart = [...stages]
            .filter((stage) => stage.planned.start_date)
            .sort(
                (stageA, stageB) =>
                    moment(stageA.planned.start_date).valueOf() -
                    moment(stageB.planned.start_date).valueOf()
            )[0]?.planned.start_date;

        thunkApi.dispatch(gantActions.changeFirstStageStart(firstStageStart));
        thunkApi.dispatch(positionsConnectionsActions.setConnections(connections));

        return stages;
    } catch (e) {
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});
